export const SKIPQ1 = 'wq'
export const CATEGORIES = 'categories'
export const PERSONA_OPTIONS = 'ps' // pen-5209_v1_quiz_user_persona_question

type SkipMap = {
  skipQ1?: boolean
}

export const useSkipParams = (qp: unknown): SkipMap => {
  const skip = parse(qp)
  if (!skip) {
    return {
      skipQ1: undefined,
    }
  }
  return skip
}

const parse = (qp: unknown): SkipMap | null => {
  if (!qp) return null
  if (typeof qp !== 'object') return null
  return {
    skipQ1: SKIPQ1 in qp ? !!qp[SKIPQ1] : undefined,
  }
}
